/* =========================================================
   VFW Grid BG — the infinite-grid cursor spotlight (P6)
   Dependency-free custom element: tracks the pointer over its
   host container and writes --mx/--my (percent) so the CSS
   bronze radial glow follows the cursor. Grid drift + base glow
   are pure CSS; this only adds the user-held spotlight.

   Host = the nearest positioned ancestor it decorates (its
   parent element). Reduced motion / no pointer / no JS: never
   arms — the glow rests at its default position. rAF-throttled.
   ========================================================= */

(() => {
  if (customElements.get('vfw-grid-bg')) return;

  class VfwGridBg extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) return;

      this.host = this.parentElement;
      if (!this.host) return;

      this.raf = 0;
      this.onMove = (e) => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          const r = this.host.getBoundingClientRect();
          if (!r.width || !r.height) return;
          const x = ((e.clientX - r.left) / r.width) * 100;
          const y = ((e.clientY - r.top) / r.height) * 100;
          this.style.setProperty('--mx', x.toFixed(1) + '%');
          this.style.setProperty('--my', y.toFixed(1) + '%');
        });
      };

      this.host.addEventListener('pointermove', this.onMove, { passive: true });
    }

    disconnectedCallback() {
      if (this.host && this.onMove) this.host.removeEventListener('pointermove', this.onMove);
      if (this.raf) cancelAnimationFrame(this.raf);
    }
  }

  customElements.define('vfw-grid-bg', VfwGridBg);
})();
